import React, { useEffect, useState } from 'react';
import './MerchantMetrics.css';
import backIcon from '../../assets/backspace-icon.png';
import api from '../../api';
import { useNavigate } from 'react-router-dom';

// Format Pi values
const formatPi = (val) => (val ? parseFloat(val).toFixed(2) : '0.00');

function MerchantMetrics({ user }) {
  const [data, setData] = useState(null);
  const [activeTab, setActiveTab] = useState('store');
  const navigate = useNavigate();

  useEffect(() => {
    fetchMerchantMetrics();
  }, []);

  const fetchMerchantMetrics = async () => {
    try {
      console.log('📡 Fetching metrics for:', user.username);
      const res = await api.get(`/merchants/metrics/${user.username}`);
      setData(res.data);
    } catch (err) {
      console.error('❌ Failed to fetch merchant metrics:', err);
    }
  };

  const renderStatCard = (label, value) => (
    <div className="metric-card">
      <div className="metric-card-title">{label}</div>
      <div className="metric-card-value">{value ?? '—'}</div>
    </div>
  );

  const renderStats = () => {
    if (!data) return <div className="metrics-loading">Loading...</div>;

    switch (activeTab) {
      case 'store':
        return (
          <div className="metrics-grid">
            {renderStatCard('Total Products', data.totalProducts)}
            {renderStatCard('Total Orders', data.totalOrders)}
          </div>
        );

      case 'orders':
        return (
          <div className="metrics-grid">
            {renderStatCard('Pending Orders', data.pendingOrders)}
            {renderStatCard('Completed Orders', data.completedOrders)}
            {renderStatCard('Cancelled Orders', data.cancelledOrders)}
            {renderStatCard('Disputed Orders', data.disputedOrders)}
          </div>
        );

      case 'revenue':
        return (
          <div className="metrics-grid">
            {renderStatCard('💰 Total Revenue', `${formatPi(data.totalRevenue)}π`)}
            {renderStatCard('📦 Escrow Earnings (All Time)', `${formatPi(data.escrowEarningsAllTime)}π`)}
            {renderStatCard('📅 Escrow Earnings (This Month)', `${formatPi(data.escrowEarningsThisMonth)}π`)}
            {renderStatCard('🎯 Sponsorships Spent', `${formatPi(data.totalSponsorshipSpent)}π`)}
          </div>
        );

      case 'reviews':
        return (
          <div className="metrics-grid">
            {renderStatCard('Total Reviews', data.reviewsCount)}
            {renderStatCard('Average Rating', `${data.avgRating?.toFixed(1) ?? 'N/A'} ★`)}
          </div>
        );

      default:
        return null;
    }
  };

  return (
    <div className="merchant-metrics-container">
      <div className="metrics-topbar">
        <img
          src={backIcon}
          alt="Back"
          className="back-arrow"
          onClick={() => navigate('/merchant/dashboard')}
        />
        <span className="metrics-title">Store Metrics</span>
      </div>

      <div className="metrics-filter">
        <button className={activeTab === 'store' ? 'active' : ''} onClick={() => setActiveTab('store')}>🛍 Store</button>
        <button className={activeTab === 'orders' ? 'active' : ''} onClick={() => setActiveTab('orders')}>📦 Orders</button>
        <button className={activeTab === 'revenue' ? 'active' : ''} onClick={() => setActiveTab('revenue')}>💰 Revenue</button>
        <button className={activeTab === 'reviews' ? 'active' : ''} onClick={() => setActiveTab('reviews')}>⭐ Reviews</button>
      </div>

      <div className="metrics-content">{renderStats()}</div>
    </div>
  );
}

export default MerchantMetrics;
